import {
  formatCurrency,
  formatEasiScore,
  formatWithCommas,
} from "../../utils/formatters";
import { RegionTooltipAttribute } from "../../ts-types/mapsTypes";

export const formatRegionAttribute = (
  field: string | number,
  attribute: RegionTooltipAttribute,
) => {
  const { format = "DEFAULT" } = attribute;
  if (format === "DEFAULT") {
    return field;
  } else if (format === "PERCENTAGE") {
    return `${field}%`;
  } else if (format === "DECIMALS_1") {
    const num = Number(field);
    return num.toFixed(1);
  } else if (format === "DECIMALS_2") {
    const num = Number(field);
    return num.toFixed(2);
  } else if (format === "EASI") {
    const num = Number(field);
    return formatEasiScore(num);
  } else if (format === "INTEGER") {
    const num = Math.round(Number(field));
    return formatWithCommas(num);
  } else if (format === "CURRENCY") {
    return formatCurrency(field);
  } else if (format === "DATE") {
    const str = String(field);
    if (str.length >= 8 && /^\d{8,14}$/.test(str)) {
      const m = str.slice(4, 6);
      const d = str.slice(6, 8);
      const y = str.slice(0, 4);
      return `${m}/${d}/${y}`;
    }
    const num = Number(field);
    if (isNaN(num)) return field;
    return new Date(num).toLocaleDateString();
  } else if (format === "TIMESTAMP_MS") {
    const num = Number(field);
    if (isNaN(num)) return field;
    return new Date(num).toLocaleDateString();
  }

  return field;
};
